import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useToastr from '../../hooks/useToastr';
import { approveAffiliate } from '../../services/Affiliates';

const ApprovalDialog = ({ onClose, onSave, editId }) => {
  const { showErrorToastr, showSuccessToastr } = useToastr();
  const [processing, setProcessing] = useState(false);

  const onSubmit = async () => {
    try {
      setProcessing(true);
      await approveAffiliate({
        documentId: editId,
      });
      showSuccessToastr('Affiliate updated successfully.');
      onSave();
    } catch (error) {
      showErrorToastr(error?.response?.data?.message || error?.message || 'Something went wrong.');
      setProcessing(false);
      onClose();
    }
  };

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>Approve Affiliate</DialogTitle>
      <DialogContent>Are u sure want to approve this affiliate?</DialogContent>
      <DialogActions>
        <Button
          type="submit"
          form="manage-approvals"
          endIcon={processing && <CircularProgress size={25} />}
          disabled={processing}
          color="primary"
          variant="contained"
          disableElevation
          onClick={onSubmit}
        >
          Approve
        </Button>
        <Button onClick={onClose} variant="contained" disableElevation>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalDialog;

ApprovalDialog.propTypes = {
  editId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
